import { AnalysisOutputCodeParameter } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is an AnalysisOutputCodeParameter object.
 *
 * @param obj - The value to check.
 * @returns True when the value has a valid AnalysisOutputCodeParameter shape.
 */
export const isAnalysisOutputCodeParameter = (obj: unknown): obj is AnalysisOutputCodeParameter => {
  // Check type
  if (!isObjectRecord(obj)) return false;

  // Check Properties
  if (!Array.isArray(obj.value) || obj.value.some((value) => typeof value !== "string"))
    return false;
  if (typeof obj.name !== "string") return false;
  if (["string", "undefined"].includes(typeof obj.description) === false) return false;
  if (["string", "undefined"].includes(typeof obj.label) === false) return false;

  // Everything is good
  return true;
};
